document.addEventListener("DOMContentLoaded", function () {
  function refreshCartDrawer() {
    fetch(window.location.pathname, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Replace the cart drawer content with the latest content from the server
        const newCartDrawer = doc.querySelector("cart-drawer-items");
        const existingCartDrawer = document.querySelector("cart-drawer-items");

        if (newCartDrawer && existingCartDrawer) {
          existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
          console.log("Cart drawer refreshed successfully.");
        } else {
          console.log("Cart drawer elements not found.");
        }
      })
      .catch((error) => console.error("Error refreshing cart drawer:", error));
  }

  const checkAndBindSliderEvents = () => {
    const checkInterval = setInterval(() => {
      const cartDrawerItems = document.querySelector("cart-drawer-items");

      if (cartDrawerItems) {
        const slider = document.querySelector(
          "#essential_product_slider_cm1kcz859183021192hwy4earen"
        );

        if (slider) {
          clearInterval(checkInterval);
          const slides = document.querySelectorAll(
            ".free_shipping_card_product_cta_cm1kcz859183021192hwy4earen"
          );

          slides.forEach((ctaElement) => {
            ctaElement.addEventListener("click", function (event) {
              ctaElement.style.pointerEvents = "none";
              ctaElement.style.opacity = "0.5";
              // ctaElement.innerHTML = 'Adding';
              //             const spinner = document.createElement('div');
              // spinner.classList.add('loading-overlay__spinner');  // Add a class to style the spinner
              // ctaElement.appendChild(spinner);
              setTimeout(() => {
                const cartItemsElement =
                  document.querySelector("cart-drawer-items") ||
                  document.querySelector("cart-items");

                if (cartItemsElement) {
                  document.dispatchEvent(
                    new CustomEvent("cart:build", { bubbles: true })
                  );
                  document.dispatchEvent(
                    new CustomEvent("cart:refresh", { bubbles: true })
                  );

                  refreshCartDrawer();
                  checkAndBindSliderEvents();
                }
              }, 1000);
            });
          });
        }
      } else {
        console.log("CartDrawerItems element not found in the DOM.");
      }
    }, 4000);
  };

  checkAndBindSliderEvents();
});
